// Predefined Laboratory Orders Configuration
// Based on clinical categories and Vietnamese healthcare standards

export const predefinedLabOrders = {
  // 1. Hematology / Huyết học
  hematology: {
    id: 'hematology',
    nameEn: 'Hematology',
    nameVi: 'Huyết học',
    color: '#ff4d4f',
    icon: '🩸',
    orders: [
      {
        id: 'cbc_cth',
        nameEn: 'Complete Blood Count (CBC)',
        nameVi: 'Công thức máu (CTM)',
        testName: 'Complete Blood Count (CBC)',
        specimenType: 'Blood',
        category: 'Hematology',
        description: 'Complete blood count with differential',
        labTemplate: 'CBC'
      },
      {
        id: 'cbc_5_parts',
        nameEn: 'CBC + 5-part differential',
        nameVi: 'Công thức máu + Phân loại bạch cầu 5 thành phần',
        testName: 'CBC with 5-part differential',
        specimenType: 'Blood',
        category: 'Hematology',
        description: 'Complete blood count with 5-part white cell differential'
      },
      {
        id: 'esr',
        nameEn: 'Erythrocyte Sedimentation Rate (ESR)',
        nameVi: 'Tốc độ máu lắng (ESR)',
        testName: 'ESR',
        specimenType: 'Blood',
        category: 'Hematology',
        description: 'Erythrocyte sedimentation rate'
      },
      {
        id: 'hemoglobin',
        nameEn: 'Hemoglobin',
        nameVi: 'Huyết sắc tố',
        testName: 'Hemoglobin',
        specimenType: 'Blood',
        category: 'Hematology',
        description: 'Hemoglobin concentration'
      },
      {
        id: 'hematocrit',
        nameEn: 'Hematocrit',
        nameVi: 'Dung tích hồng cầu',
        testName: 'Hematocrit',
        specimenType: 'Blood',
        category: 'Hematology',
        description: 'Hematocrit percentage'
      }
    ]
  },

  // 2. Coagulation / Đông máu
  coagulation: {
    id: 'coagulation',
    nameEn: 'Coagulation',
    nameVi: 'Đông máu',
    color: '#722ed1',
    icon: '🩸',
    orders: [
      {
        id: 'pt_inr',
        nameEn: 'PT/INR',
        nameVi: 'PT/INR',
        testName: 'Prothrombin Time/INR',
        specimenType: 'Blood',
        category: 'Coagulation',
        description: 'Prothrombin time and international normalized ratio'
      },
      {
        id: 'aptt',
        nameEn: 'APTT (aPTT)',
        nameVi: 'APTT (aPTT)',
        testName: 'Activated Partial Thromboplastin Time',
        specimenType: 'Blood',
        category: 'Coagulation',
        description: 'Activated partial thromboplastin time'
      },
      {
        id: 'fibrinogen',
        nameEn: 'Fibrinogen',
        nameVi: 'Fibrinogen',
        testName: 'Fibrinogen',
        specimenType: 'Blood',
        category: 'Coagulation',
        description: 'Fibrinogen level'
      },
      {
        id: 'd_dimer',
        nameEn: 'D-dimer',
        nameVi: 'D-dimer',
        testName: 'D-dimer',
        specimenType: 'Blood',
        category: 'Coagulation',
        description: 'D-dimer fibrin degradation product'
      }
    ]
  },

  // 3. Comprehensive Biochemistry / Sinh hóa tổng hợp
  biochemistry: {
    id: 'biochemistry',
    nameEn: 'Comprehensive Biochemistry',
    nameVi: 'Sinh hóa tổng hợp',
    color: '#1890ff',
    icon: '🧪',
    orders: [
      {
        id: 'glucose',
        nameEn: 'Glucose',
        nameVi: 'Glucose',
        testName: 'Glucose',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Blood glucose level'
      },
      {
        id: 'urea',
        nameEn: 'Urea',
        nameVi: 'Urea',
        testName: 'Urea',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Blood urea nitrogen'
      },
      {
        id: 'creatinine',
        nameEn: 'Creatinine',
        nameVi: 'Creatinine',
        testName: 'Creatinine',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Serum creatinine'
      },
      {
        id: 'uric_acid',
        nameEn: 'Uric Acid',
        nameVi: 'Acid Uric',
        testName: 'Uric Acid',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Serum uric acid'
      },
      {
        id: 'total_protein',
        nameEn: 'Total Protein',
        nameVi: 'Protein toàn phần',
        testName: 'Total Protein',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Total serum protein'
      },
      {
        id: 'albumin',
        nameEn: 'Albumin',
        nameVi: 'Albumin',
        testName: 'Albumin',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Serum albumin'
      },
      {
        id: 'total_bilirubin',
        nameEn: 'Total Bilirubin',
        nameVi: 'Bilirubin toàn phần',
        testName: 'Total Bilirubin',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Total bilirubin'
      },
      {
        id: 'direct_bilirubin',
        nameEn: 'Direct Bilirubin',
        nameVi: 'Bilirubin trực tiếp',
        testName: 'Direct Bilirubin',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Direct (conjugated) bilirubin'
      },
      {
        id: 'ast',
        nameEn: 'AST (SGOT)',
        nameVi: 'AST (SGOT)',
        testName: 'AST',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Aspartate aminotransferase'
      },
      {
        id: 'alt',
        nameEn: 'ALT (SGPT)',
        nameVi: 'ALT (SGPT)',
        testName: 'ALT',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Alanine aminotransferase'
      },
      {
        id: 'alp',
        nameEn: 'Alkaline Phosphatase',
        nameVi: 'Alkaline Phosphatase',
        testName: 'Alkaline Phosphatase',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Alkaline phosphatase'
      },
      {
        id: 'ggt',
        nameEn: 'GGT',
        nameVi: 'GGT',
        testName: 'Gamma-Glutamyl Transferase',
        specimenType: 'Blood',
        category: 'Biochemistry',
        description: 'Gamma-glutamyl transferase'
      }
    ]
  },

  // 4. Thyroid Gland / Tuyến giáp
  thyroid: {
    id: 'thyroid',
    nameEn: 'Thyroid Gland',
    nameVi: 'Tuyến giáp',
    color: '#52c41a',
    icon: '🦋',
    orders: [
      {
        id: 'tsh',
        nameEn: 'TSH',
        nameVi: 'TSH',
        testName: 'Thyroid Stimulating Hormone',
        specimenType: 'Blood',
        category: 'Thyroid',
        description: 'Thyroid stimulating hormone'
      },
      {
        id: 'free_t3',
        nameEn: 'Free T3',
        nameVi: 'Free T3',
        testName: 'Free Triiodothyronine',
        specimenType: 'Blood',
        category: 'Thyroid',
        description: 'Free triiodothyronine'
      },
      {
        id: 'free_t4',
        nameEn: 'Free T4',
        nameVi: 'Free T4',
        testName: 'Free Thyroxine',
        specimenType: 'Blood',
        category: 'Thyroid',
        description: 'Free thyroxine'
      },
      {
        id: 'anti_tpo',
        nameEn: 'Anti-TPO',
        nameVi: 'Anti-TPO',
        testName: 'Anti-Thyroid Peroxidase',
        specimenType: 'Blood',
        category: 'Thyroid',
        description: 'Anti-thyroid peroxidase antibodies'
      }
    ]
  },

  // 5. Urine / Nước tiểu
  urine: {
    id: 'urine',
    nameEn: 'Urine',
    nameVi: 'Nước tiểu',
    color: '#faad14',
    icon: '🧪',
    orders: [
      {
        id: 'urinalysis',
        nameEn: 'Urinalysis (Complete)',
        nameVi: 'Tổng phân tích nước tiểu đầy đủ',
        testName: 'Complete Urinalysis',
        specimenType: 'Urine',
        category: 'Urine',
        description: 'Complete urine analysis including microscopy'
      },
      {
        id: 'urine_culture',
        nameEn: 'Urine Culture',
        nameVi: 'Cấy nước tiểu',
        testName: 'Urine Culture',
        specimenType: 'Urine',
        category: 'Urine',
        description: 'Urine culture and sensitivity'
      },
      {
        id: 'urine_protein',
        nameEn: 'Urine Protein',
        nameVi: 'Protein nước tiểu',
        testName: 'Urine Protein',
        specimenType: 'Urine',
        category: 'Urine',
        description: 'Urine protein quantification'
      },
      {
        id: 'microalbumin',
        nameEn: 'Microalbumin',
        nameVi: 'Microalbumin',
        testName: 'Microalbumin',
        specimenType: 'Urine',
        category: 'Urine',
        description: 'Urine microalbumin'
      },
      {
        id: 'creatinine_clearance',
        nameEn: 'Creatinine Clearance',
        nameVi: 'Độ thanh thải Creatinine',
        testName: 'Creatinine Clearance',
        specimenType: 'Urine',
        category: 'Urine',
        description: '24-hour urine creatinine clearance'
      }
    ]
  },

  // 6. Cardiovascular / Tim mạch
  cardiovascular: {
    id: 'cardiovascular',
    nameEn: 'Cardiovascular',
    nameVi: 'Tim mạch',
    color: '#f5222d',
    icon: '❤️',
    orders: [
      {
        id: 'troponin_i',
        nameEn: 'Troponin I',
        nameVi: 'Troponin I',
        testName: 'Troponin I',
        specimenType: 'Blood',
        category: 'Cardiovascular',
        description: 'Cardiac troponin I'
      },
      {
        id: 'troponin_t',
        nameEn: 'Troponin T (hs)',
        nameVi: 'Troponin T (hs)',
        testName: 'High-sensitivity Troponin T',
        specimenType: 'Blood',
        category: 'Cardiovascular',
        description: 'High-sensitivity troponin T'
      },
      {
        id: 'nt_probnp',
        nameEn: 'NT-proBNP',
        nameVi: 'NT-proBNP',
        testName: 'NT-proBNP',
        specimenType: 'Blood',
        category: 'Cardiovascular',
        description: 'N-terminal pro-B-type natriuretic peptide'
      },
      {
        id: 'apolipoprotein_b',
        nameEn: 'Apolipoprotein B (ApoB)',
        nameVi: 'Apolipoprotein B (ApoB)',
        testName: 'Apolipoprotein B',
        specimenType: 'Blood',
        category: 'Cardiovascular',
        description: 'Apolipoprotein B'
      },
      {
        id: 'apolipoprotein_a1',
        nameEn: 'Apolipoprotein A-I (ApoA-I)',
        nameVi: 'Apolipoprotein A-I (ApoA-I)',
        testName: 'Apolipoprotein A-I',
        specimenType: 'Blood',
        category: 'Cardiovascular',
        description: 'Apolipoprotein A-I'
      },
      {
        id: 'ck_mb',
        nameEn: 'CK-MB',
        nameVi: 'CK-MB',
        testName: 'Creatine Kinase-MB',
        specimenType: 'Blood',
        category: 'Cardiovascular',
        description: 'Creatine kinase MB fraction'
      }
    ]
  },

  // 7. Viral Hepatitis / Viêm gan siêu vi
  viralHepatitis: {
    id: 'viralHepatitis',
    nameEn: 'Viral Hepatitis',
    nameVi: 'Viêm gan siêu vi',
    color: '#fa8c16',
    icon: '🦠',
    orders: [
      {
        id: 'hbsag',
        nameEn: 'HBsAg (Hepatitis B Surface Antigen)',
        nameVi: 'Kháng nguyên bề mặt viêm gan B (HBsAg)',
        testName: 'HBsAg',
        specimenType: 'Blood',
        category: 'Viral Hepatitis',
        description: 'Hepatitis B surface antigen'
      },
      {
        id: 'anti_hbs',
        nameEn: 'Anti-HBs (Hepatitis B Surface Antibody)',
        nameVi: 'Kháng thể bề mặt viêm gan B (Anti-HBs)',
        testName: 'Anti-HBs',
        specimenType: 'Blood',
        category: 'Viral Hepatitis',
        description: 'Hepatitis B surface antibody'
      },
      {
        id: 'anti_hbc',
        nameEn: 'Anti-HBc (Hepatitis B Core Antibody)',
        nameVi: 'Kháng thể lõi viêm gan B (Anti-HBc)',
        testName: 'Anti-HBc',
        specimenType: 'Blood',
        category: 'Viral Hepatitis',
        description: 'Hepatitis B core antibody'
      },
      {
        id: 'hbeag',
        nameEn: 'HBeAg (Hepatitis B e Antigen)',
        nameVi: 'Kháng nguyên e viêm gan B (HBeAg)',
        testName: 'HBeAg',
        specimenType: 'Blood',
        category: 'Viral Hepatitis',
        description: 'Hepatitis B e antigen'
      },
      {
        id: 'anti_hbe',
        nameEn: 'Anti-HBe (Hepatitis B e Antibody)',
        nameVi: 'Kháng thể e viêm gan B (Anti-HBe)',
        testName: 'Anti-HBe',
        specimenType: 'Blood',
        category: 'Viral Hepatitis',
        description: 'Hepatitis B e antibody'
      },
      {
        id: 'anti_hcv',
        nameEn: 'Anti-HCV (Hepatitis C Antibody)',
        nameVi: 'Kháng thể viêm gan C (Anti-HCV)',
        testName: 'Anti-HCV',
        specimenType: 'Blood',
        category: 'Viral Hepatitis',
        description: 'Hepatitis C antibody'
      },
      {
        id: 'hcv_rna_pcr',
        nameEn: 'HCV RNA PCR',
        nameVi: 'HCV RNA PCR',
        testName: 'HCV RNA PCR',
        specimenType: 'Blood',
        category: 'Viral Hepatitis',
        description: 'Hepatitis C RNA by PCR'
      },
      {
        id: 'hbv_dna_pcr',
        nameEn: 'HBV DNA PCR',
        nameVi: 'HBV DNA PCR',
        testName: 'HBV DNA PCR',
        specimenType: 'Blood',
        category: 'Viral Hepatitis',
        description: 'Hepatitis B DNA by PCR'
      }
    ]
  },

  // 8. Infection / Lây nhiễm
  infection: {
    id: 'infection',
    nameEn: 'Infection',
    nameVi: 'Lây nhiễm',
    color: '#eb2f96',
    icon: '🦠',
    orders: [
      {
        id: 'hiv_combo',
        nameEn: 'HIV Combo (Ag + Ab)',
        nameVi: 'HIV Combo (Ag + Ab)',
        testName: 'HIV Combo Test',
        specimenType: 'Blood',
        category: 'Infection',
        description: 'HIV antigen and antibody combo test'
      },
      {
        id: 'hiv_viral_load',
        nameEn: 'HIV Viral Load',
        nameVi: 'Tải lượng virus HIV',
        testName: 'HIV Viral Load',
        specimenType: 'Blood',
        category: 'Infection',
        description: 'HIV viral load quantification'
      },
      {
        id: 'syphilis_rpr',
        nameEn: 'Syphilis (RPR)',
        nameVi: 'Giang mai (RPR)',
        testName: 'Syphilis RPR',
        specimenType: 'Blood',
        category: 'Infection',
        description: 'Rapid plasma reagin test for syphilis'
      }
    ]
  },

  // 9. Tumor Markers / Dấu ấn ung thư
  tumorMarkers: {
    id: 'tumorMarkers',
    nameEn: 'Tumor Markers',
    nameVi: 'Dấu ấn ung thư',
    color: '#722ed1',
    icon: '🎯',
    orders: [
      {
        id: 'cea',
        nameEn: 'CEA (Carcinoembryonic Antigen)',
        nameVi: 'CEA (Kháng nguyên phôi ung thư)',
        testName: 'CEA',
        specimenType: 'Blood',
        category: 'Tumor Markers',
        description: 'Carcinoembryonic antigen'
      },
      {
        id: 'ca_125',
        nameEn: 'CA 125 (Ovarian Cancer)',
        nameVi: 'CA 125 (Ung thư buồng trứng)',
        testName: 'CA 125',
        specimenType: 'Blood',
        category: 'Tumor Markers',
        description: 'Cancer antigen 125'
      },
      {
        id: 'ca_199',
        nameEn: 'CA 19-9 (Pancreatic Cancer)',
        nameVi: 'CA 19-9 (Ung thư tuyến tụy)',
        testName: 'CA 19-9',
        specimenType: 'Blood',
        category: 'Tumor Markers',
        description: 'Cancer antigen 19-9'
      },
      {
        id: 'ca_153',
        nameEn: 'CA 15-3 (Breast Cancer)',
        nameVi: 'CA 15-3 (Ung thư vú)',
        testName: 'CA 15-3',
        specimenType: 'Blood',
        category: 'Tumor Markers',
        description: 'Cancer antigen 15-3'
      },
      {
        id: 'psa_total',
        nameEn: 'PSA Total (Prostate)',
        nameVi: 'PSA toàn phần (Tuyến tiền liệt)',
        testName: 'PSA Total',
        specimenType: 'Blood',
        category: 'Tumor Markers',
        description: 'Total prostate-specific antigen'
      },
      {
        id: 'psa_free',
        nameEn: 'PSA Free (Prostate)',
        nameVi: 'PSA tự do (Tuyến tiền liệt)',
        testName: 'PSA Free',
        specimenType: 'Blood',
        category: 'Tumor Markers',
        description: 'Free prostate-specific antigen'
      },
      {
        id: 'afp',
        nameEn: 'AFP (Alpha-fetoprotein)',
        nameVi: 'AFP (Alpha-fetoprotein)',
        testName: 'Alpha-fetoprotein',
        specimenType: 'Blood',
        category: 'Tumor Markers',
        description: 'Alpha-fetoprotein'
      }
    ]
  },

  // 10. Parasites / Ký sinh trung
  parasites: {
    id: 'parasites',
    nameEn: 'Parasites',
    nameVi: 'Ký sinh trung',
    color: '#13c2c2',
    icon: '🪱',
    orders: [
      {
        id: 'stool_parasites',
        nameEn: 'Stool Parasites Examination',
        nameVi: 'Soi ký sinh trung phân',
        testName: 'Stool Parasites',
        specimenType: 'Stool',
        category: 'Parasites',
        description: 'Microscopic examination for parasites in stool'
      },
      {
        id: 'malaria_smear',
        nameEn: 'Malaria Blood Smear',
        nameVi: 'Soi sốt rét',
        testName: 'Malaria Smear',
        specimenType: 'Blood',
        category: 'Parasites',
        description: 'Blood smear for malaria parasites'
      }
    ]
  },

  // 11. Cervical Cancer Screening / Tầm soát ung thư cổ tử cung
  cervicalCancer: {
    id: 'cervicalCancer',
    nameEn: 'Cervical Cancer Screening',
    nameVi: 'Tầm soát ung thư cổ tử cung',
    color: '#f759ab',
    icon: '🔬',
    orders: [
      {
        id: 'pap_smear',
        nameEn: 'Pap Smear (Cervical Cytology)',
        nameVi: 'Tế bào học cổ tử cung (Pap Smear)',
        testName: 'Pap Smear',
        specimenType: 'Cervical',
        category: 'Cervical Cancer',
        description: 'Cervical cytology screening'
      },
      {
        id: 'hpv_dna',
        nameEn: 'HPV DNA Test',
        nameVi: 'Xét nghiệm HPV DNA',
        testName: 'HPV DNA',
        specimenType: 'Cervical',
        category: 'Cervical Cancer',
        description: 'Human papillomavirus DNA test'
      }
    ]
  },

  // 12. STDs / Bệnh lây nhiễm đường tình dục
  stds: {
    id: 'stds',
    nameEn: 'STDs',
    nameVi: 'Bệnh lây nhiễm đường tình dục',
    color: '#ff7a45',
    icon: '⚠️',
    orders: [
      {
        id: 'syphilis_tppa',
        nameEn: 'Syphilis TPPA',
        nameVi: 'Giang mai TPPA',
        testName: 'Syphilis TPPA',
        specimenType: 'Blood',
        category: 'STDs',
        description: 'Treponema pallidum particle agglutination'
      },
      {
        id: 'sds_rapid_plasma_reagin',
        nameEn: 'SDS Rapid Plasma Reagin',
        nameVi: 'SDS Rapid Plasma Reagin',
        testName: 'SDS RPR',
        specimenType: 'Blood',
        category: 'STDs',
        description: 'SDS rapid plasma reagin test'
      }
    ]
  },

  // 13. Obstetrics and Gynecology / Sản phụ khoa
  obstetrics: {
    id: 'obstetrics',
    nameEn: 'Obstetrics and Gynecology',
    nameVi: 'Sản phụ khoa',
    color: '#ff85c0',
    icon: '👶',
    orders: [
      {
        id: 'beta_hcg',
        nameEn: 'Beta-hCG (Pregnancy Test)',
        nameVi: 'Beta-hCG (Test thai)',
        testName: 'Beta-hCG',
        specimenType: 'Blood',
        category: 'Obstetrics',
        description: 'Beta human chorionic gonadotropin'
      },
      {
        id: 'lh',
        nameEn: 'LH (Luteinizing Hormone)',
        nameVi: 'LH (Hormone hoàng thể)',
        testName: 'Luteinizing Hormone',
        specimenType: 'Blood',
        category: 'Obstetrics',
        description: 'Luteinizing hormone'
      },
      {
        id: 'fsh',
        nameEn: 'FSH (Follicle Stimulating Hormone)',
        nameVi: 'FSH (Hormone kích thích nang trứng)',
        testName: 'Follicle Stimulating Hormone',
        specimenType: 'Blood',
        category: 'Obstetrics',
        description: 'Follicle stimulating hormone'
      },
      {
        id: 'estradiol',
        nameEn: 'Estradiol',
        nameVi: 'Estradiol',
        testName: 'Estradiol',
        specimenType: 'Blood',
        category: 'Obstetrics',
        description: 'Estradiol hormone'
      },
      {
        id: 'progesterone',
        nameEn: 'Progesterone',
        nameVi: 'Progesterone',
        testName: 'Progesterone',
        specimenType: 'Blood',
        category: 'Obstetrics',
        description: 'Progesterone hormone'
      }
    ]
  },

  // 14. Hormones / Nội tiết tố
  hormones: {
    id: 'hormones',
    nameEn: 'Hormones',
    nameVi: 'Nội tiết tố',
    color: '#9254de',
    icon: '⚗️',
    orders: [
      {
        id: 'aldosterone',
        nameEn: 'Aldosterone',
        nameVi: 'Aldosterone',
        testName: 'Aldosterone',
        specimenType: 'Blood',
        category: 'Hormones',
        description: 'Aldosterone hormone'
      },
      {
        id: 'cortisol',
        nameEn: 'Cortisol',
        nameVi: 'Cortisol',
        testName: 'Cortisol',
        specimenType: 'Blood',
        category: 'Hormones',
        description: 'Cortisol hormone'
      },
      {
        id: 'testosterone',
        nameEn: 'Testosterone',
        nameVi: 'Testosterone',
        testName: 'Testosterone',
        specimenType: 'Blood',
        category: 'Hormones',
        description: 'Testosterone hormone'
      },
      {
        id: 'dheas',
        nameEn: 'DHEA-S',
        nameVi: 'DHEA-S',
        testName: 'DHEA-Sulfate',
        specimenType: 'Blood',
        category: 'Hormones',
        description: 'Dehydroepiandrosterone sulfate'
      },
      {
        id: 'hgh',
        nameEn: 'HGH (Human Growth Hormone)',
        nameVi: 'HGH (Hormone tăng trưởng)',
        testName: 'Human Growth Hormone',
        specimenType: 'Blood',
        category: 'Hormones',
        description: 'Human growth hormone'
      },
      {
        id: 'igf1',
        nameEn: 'IGF-1',
        nameVi: 'IGF-1',
        testName: 'Insulin-like Growth Factor 1',
        specimenType: 'Blood',
        category: 'Hormones',
        description: 'Insulin-like growth factor 1'
      }
    ]
  },

  // 15. Lipid Profile / Lipid máu
  lipidProfile: {
    id: 'lipidProfile',
    nameEn: 'Lipid Profile',
    nameVi: 'Lipid máu',
    color: '#fa541c',
    icon: '🧬',
    orders: [
      {
        id: 'total_cholesterol',
        nameEn: 'Total Cholesterol',
        nameVi: 'Cholesterol toàn phần',
        testName: 'Total Cholesterol',
        specimenType: 'Blood',
        category: 'Lipid Profile',
        description: 'Total cholesterol level'
      },
      {
        id: 'hdl_cholesterol',
        nameEn: 'HDL Cholesterol',
        nameVi: 'HDL Cholesterol',
        testName: 'HDL Cholesterol',
        specimenType: 'Blood',
        category: 'Lipid Profile',
        description: 'High-density lipoprotein cholesterol'
      },
      {
        id: 'ldl_cholesterol',
        nameEn: 'LDL Cholesterol',
        nameVi: 'LDL Cholesterol',
        testName: 'LDL Cholesterol',
        specimenType: 'Blood',
        category: 'Lipid Profile',
        description: 'Low-density lipoprotein cholesterol'
      },
      {
        id: 'triglycerides',
        nameEn: 'Triglycerides',
        nameVi: 'Triglycerides',
        testName: 'Triglycerides',
        specimenType: 'Blood',
        category: 'Lipid Profile',
        description: 'Triglyceride level'
      },
      {
        id: 'lipid_panel_complete',
        nameEn: 'Complete Lipid Panel',
        nameVi: 'Bộ xét nghiệm Lipid đầy đủ',
        testName: 'Complete Lipid Panel',
        specimenType: 'Blood',
        category: 'Lipid Profile',
        description: 'Complete lipid profile including cholesterol, HDL, LDL, and triglycerides'
      }
    ]
  },

  // 16. Diabetes / Tiểu đường
  diabetes: {
    id: 'diabetes',
    nameEn: 'Diabetes',
    nameVi: 'Tiểu đường',
    color: '#d4b106',
    icon: '🍯',
    orders: [
      {
        id: 'fasting_glucose',
        nameEn: 'Fasting Glucose',
        nameVi: 'Glucose lúc đói',
        testName: 'Fasting Blood Glucose',
        specimenType: 'Blood',
        category: 'Diabetes',
        description: 'Fasting blood glucose level'
      },
      {
        id: 'random_glucose',
        nameEn: 'Random Glucose',
        nameVi: 'Glucose bất kỳ',
        testName: 'Random Blood Glucose',
        specimenType: 'Blood',
        category: 'Diabetes',
        description: 'Random blood glucose level'
      },
      {
        id: 'hba1c',
        nameEn: 'HbA1c (Glycated Hemoglobin)',
        nameVi: 'HbA1c (Hemoglobin đường hóa)',
        testName: 'HbA1c',
        specimenType: 'Blood',
        category: 'Diabetes',
        description: 'Glycated hemoglobin (3-month average glucose)'
      },
      {
        id: 'ogtt',
        nameEn: 'OGTT (Oral Glucose Tolerance Test)',
        nameVi: 'OGTT (Test dung nạp glucose đường uống)',
        testName: 'Oral Glucose Tolerance Test',
        specimenType: 'Blood',
        category: 'Diabetes',
        description: 'Oral glucose tolerance test'
      },
      {
        id: 'c_peptide',
        nameEn: 'C-Peptide',
        nameVi: 'C-Peptide',
        testName: 'C-Peptide',
        specimenType: 'Blood',
        category: 'Diabetes',
        description: 'C-peptide level (insulin production marker)'
      }
    ]
  },

  // 17. Electrolytes / Điện giải
  electrolytes: {
    id: 'electrolytes',
    nameEn: 'Electrolytes',
    nameVi: 'Điện giải',
    color: '#096dd9',
    icon: '⚡',
    orders: [
      {
        id: 'sodium',
        nameEn: 'Sodium (Na+)',
        nameVi: 'Natri (Na+)',
        testName: 'Sodium',
        specimenType: 'Blood',
        category: 'Electrolytes',
        description: 'Serum sodium level'
      },
      {
        id: 'potassium',
        nameEn: 'Potassium (K+)',
        nameVi: 'Kali (K+)',
        testName: 'Potassium',
        specimenType: 'Blood',
        category: 'Electrolytes',
        description: 'Serum potassium level'
      },
      {
        id: 'chloride',
        nameEn: 'Chloride (Cl-)',
        nameVi: 'Clorua (Cl-)',
        testName: 'Chloride',
        specimenType: 'Blood',
        category: 'Electrolytes',
        description: 'Serum chloride level'
      },
      {
        id: 'co2_bicarbonate',
        nameEn: 'CO2/Bicarbonate',
        nameVi: 'CO2/Bicarbonate',
        testName: 'CO2/Bicarbonate',
        specimenType: 'Blood',
        category: 'Electrolytes',
        description: 'Carbon dioxide/bicarbonate level'
      },
      {
        id: 'electrolyte_panel',
        nameEn: 'Basic Electrolyte Panel',
        nameVi: 'Bộ điện giải cơ bản',
        testName: 'Basic Electrolyte Panel',
        specimenType: 'Blood',
        category: 'Electrolytes',
        description: 'Basic electrolyte panel (Na, K, Cl, CO2)'
      }
    ]
  }
};

// Helper function to get all orders as a flat array
export const getAllPredefinedOrders = () => {
  const allOrders = [];
  Object.values(predefinedLabOrders).forEach(category => {
    category.orders.forEach(order => {
      allOrders.push({
        ...order,
        categoryId: category.id,
        categoryName: category.nameEn,
        categoryNameVi: category.nameVi,
        categoryColor: category.color
      });
    });
  });
  return allOrders;
};

// Helper function to get orders by category
export const getOrdersByCategory = (categoryId) => {
  return predefinedLabOrders[categoryId]?.orders || [];
};

// Helper function to search orders
export const searchOrders = (searchTerm, language = 'en') => {
  const allOrders = getAllPredefinedOrders();
  const term = searchTerm.toLowerCase();
  
  return allOrders.filter(order => {
    const nameField = language === 'vi' ? 'nameVi' : 'nameEn';
    const categoryField = language === 'vi' ? 'categoryNameVi' : 'categoryName';
    
    return (
      order[nameField].toLowerCase().includes(term) ||
      order[categoryField].toLowerCase().includes(term) ||
      order.testName.toLowerCase().includes(term) ||
      order.description.toLowerCase().includes(term)
    );
  });
};
